// services/auth.service.ts

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL?.trim();

export const authService = {
    login,
    getAuthUserInfo,
    
};

interface LoginPayload {
    email: string;
    secret: string; // or 'secret', depending on your backend
}

async function login(payload: LoginPayload): Promise<any> {
    const res = await fetch(`${API_BASE_URL}/auth/token/bearer`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        },
        body: JSON.stringify(payload),
    });

    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message);
    }

    return res.json();
}

async function getAuthUserInfo(): Promise<{ data: any }> {
    const token = localStorage.getItem('fluid-token');
    const res = await fetch(`${API_BASE_URL}/auth/userinfo`, {
        headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
        },
    });

    if (!res.ok) {
        const error = await res.json();
        throw new Error(error.message);
    }

    return res.json();
}

